<script setup lang="ts">
import { computed, onBeforeMount } from '#imports';
import type { NuxtError } from 'nuxt/app';
import { responseMessages, errorPageMessages } from '@/app/messages';

const props = withDefaults(defineProps<{
	error: NuxtError;
}>(), {});

const computedStatusCode = computed(() => props.error.statusCode ?? 404);

onBeforeMount(() => console.error(props.error));
</script>

<template>
	<nuxt-layout name="error">
		<section class="page-error">
			<div class="page-error__container container">
				<h2 class="page-error__title">
					{{ responseMessages.error }} {{ computedStatusCode }}
				</h2>

				<p
					class="page-error__subtitle"
					v-html="errorPageMessages(computedStatusCode)"
				/>

				<v-link to="/" color="blue" class="page-error__link">
					На главную
				</v-link>
			</div>
		</section>
	</nuxt-layout>
</template>

<style lang="scss" scoped>
.page-error {
	&__container {
		text-align: center;
	}

	&__title {
		font-weight: 400;

		margin-bottom: rem($gap-small);

		@media #{$screen-tablet} {
			margin-bottom: rem($gap-medium);
		}
	}

	&__subtitle {
		font-weight: 700;

		margin-bottom: rem($gap-small);

		@media #{$screen-tablet} {
			margin-bottom: rem($gap-medium);
		}
	}

	&__link {
		@include text-mini;

		@media #{$screen-tablet} {
			@include text-base;
		}
	}
}
</style>
